import { SimpleGrid } from '@mantine/core'
import { plotGraphData, Duration } from '@ospace/common'

import { LeadsStatsData } from '../../hooks/useLeadsStats'

import { LeadsWidget } from './LeadWidget'
import { CircularChart } from './CircularChart'
import { LineChart } from './LineChart'

interface LeadsWidgetsProps {
  duration: Duration
  stats: LeadsStatsData
}

export function LeadsWidgets({ stats, duration }: LeadsWidgetsProps) {
  const discoveryChartData = plotGraphData(stats.discovery.chart || {}, duration)
  const discoveryChart = {
    title: 'DISCOVERY',
    left: {
      label: 'Contacts',
      value: stats.discovery.contactsCount,
    },
    right: {
      label: 'Companies discovered',
      value: stats.discovery.companiesCount,
    },
    tooltip: 'The chart displays companies discovered during the selected time period.',
    chart: LineChart,
    color: '#FFA53F',
    data: discoveryChartData.chartData.data,
    chartLabels: discoveryChartData.chartData.chartLabels,
  }

  const leadsChartData = plotGraphData(stats.lead.chart || {}, duration)
  const leadsChart = {
    title: 'NEW LEADS',
    left: {
      label: 'Leads',
      value: stats.lead.count,
    },
    right: {
      label: 'Ratio',
      value: `${stats.discovery.count}:${stats.lead.count}`,
    },
    tooltip:
      'The chart displays companies converted to leads during the selected time period. The ratio is relationship between companies discovered in the selected time period and companies that have been converted to leads in the selected time period.',
    chart: LineChart,
    color: '#C9D14D',
    data: leadsChartData.chartData.data,
    chartLabels: leadsChartData.chartData.chartLabels,
  }

  const meetingBookedChartData = plotGraphData(stats.meetingBooked.chart || {}, duration)
  const meetingBookedChart = {
    title: 'MEETINGS BOOKED',
    left: {
      label: 'Meetings',
      value: stats.meetingBooked.count,
    },
    right: {
      label: 'Ratio',
      value: `${stats.lead.count}:${stats.meetingBooked.count}`,
    },
    tooltip:
      'The chart displays leads converted to meetings during the selected time period. The ratio is relationship between leads created in the selected time period and meetings booked in the selected time period.',
    chart: LineChart,
    color: '#65C869',
    data: meetingBookedChartData.chartData.data,
    chartLabels: meetingBookedChartData.chartData.chartLabels,
  }

  const convertedLeadsCount = stats.opportunity.count || 0
  const leadsCount = stats.lead.count || 0
  const convertedLeadChart = {
    title: 'CONVERTED LEADS',
    left: {
      label: 'Total leads',
      value: leadsCount,
    },
    right: {
      label: 'Converted leads',
      value: convertedLeadsCount,
    },
    tooltip:
      'The doughnut shows the percentage of opportunities generated in the selected time period and meetings booked in the selected time period.',
    color: 'hsl(32, 100%, 62%)',
    chart: CircularChart({
      value: convertedLeadsCount,
      percentage: Math.round((convertedLeadsCount / leadsCount) * 100) || 0,
      color: '#7546AA',
    }),
    data: [],
    chartLabels: [],
  }

  const cards = [discoveryChart, leadsChart, meetingBookedChart, convertedLeadChart].map((item) => (
    <LeadsWidget {...item} key={item.title} />
  ))

  return (
    <>
      <SimpleGrid cols={4}>{cards}</SimpleGrid>
    </>
  )
}
